import { viemaxImgUrls } from '../../../constants/viemax-constants'
import Text from '../../../components/Text'

const BottomSectionWithContact = () => {
  // const handleOnContactUs = () => {
  //   console.log('contact us clicked')
  // }
  return (
    <section className="space-y-8">
      <div>
        <Text
          tag="p"
          variant="headline"
          size="large"
          className="text-[#213053] mb-6"
        >
          Your Viemax Care Program benefits
        </Text>
        <img
          src={viemaxImgUrls.notPurchased.whatToExpect}
          alt="what-to-expect"
        />
      </div>

      <div className="pb-6" />
      {/* <div className="flex items-center justify-between p-4 rounded-2xl shadow-xl border mt-6">
          <Text tag="p" variant="body" size="medium" className="text-[#344054]">
            Need Help with something?
          </Text>
          <button
            className="text-[#7500B1] text-sm"
            onClick={handleOnContactUs}
          >
            Contact Us
          </button>
        </div>
      </div> */}
    </section>
  )
}

export default BottomSectionWithContact
